export default angularModule => {
  require('./brandConfigEditor')(angularModule)
  require('./servicesConfigEditor')(angularModule)
  require('./whiteLabelConfigEditor')(angularModule)
  require('./securityConfigEditor')(angularModule)
  require('./configToggle')(angularModule)
}
